import { render } from "./EvidenceSummaryCard.vue?vue&type=template&id=07232d95&scoped=true"
import script from "./EvidenceSummaryCard.vue?vue&type=script&lang=js"
export * from "./EvidenceSummaryCard.vue?vue&type=script&lang=js"

import "./EvidenceSummaryCard.vue?vue&type=style&index=0&id=07232d95&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07232d95"]])

export default __exports__